module.exports = __webpack_public_path__ + "img/straightLineWhite.3cb3fe32.svg";